import { render, staticRenderFns } from "./ProgramTabWallets.vue?vue&type=template&id=11f58449&"
import script from "./ProgramTabWallets.vue?vue&type=script&lang=js&"
export * from "./ProgramTabWallets.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabWallets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports